<template>
  <div>
    <v-card @click="searchBoxModal = true" class="pa-2 text-xs-center" style="cursor: pointer">
      <span>Search</span>
      <v-icon>search</v-icon>
    </v-card>

    <v-dialog v-model="searchBoxModal" persistent width="600px">
      <v-card class="pa-4">
        <div class="text-xs-right">
          <v-btn @click="searchBoxModal = false" icon ripple>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="py-2">
          <div class="mt-2">
            <div class="caption">{{ $t('Search') }}</div>
            <div class="form-control">
              <input type="text" v-model="input.search" :placeholder="$t('Search')" />
            </div>
          </div>
          <div class="mt-2">
            <div class="caption">{{ $t('phone no.') }}</div>
            <div class="form-control">
              <input type="text" v-model="input.phoneno" :placeholder="$t('phone no.')" />
            </div>
          </div>
          <div class="mt-2">
            <div class="caption">{{ $t('Ticket Status') }}</div>
            <div class="form-control mb-2">
              <multiselect
                :options="ticketStatusOptions"
                v-model="input.ticketStatus"
                :placeholder="$t('Ticket Status')"
              >
              </multiselect>
            </div>
          </div>
          <div class="mt-2">
            <div class="caption">{{ $t('Tags') }}</div>
            <multiselect
              :options="tagOptions"
              v-model="input.tags"
              :placeholder="$t('Tags')"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            >
            </multiselect>
          </div>
          <div class="mt-2">
            <v-layout>
              <v-flex class="pa-1">
                <v-btn block depressed @click="clearSearch">
                  <v-icon>clear</v-icon>
                  {{ $t('Clear All') }}
                </v-btn>
              </v-flex>
              <v-flex class="pa-1">
                <v-btn block depressed @click="onSearch" color="primary">
                  <v-icon>search</v-icon>
                  {{ $t('Search') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      searchBoxModal: false,
      ticketStatusOptions: ['open', 'pending', 'answered', 'closed'],
      tagOptions: [],
      input: {
        search: '',
        phoneno: '',
        status: '',
        ticketStatus: '',
        tags: ''
      }
    }
  },
  mounted() {
    this.loadStatusAndTag()
  },
  methods: {
    async loadStatusAndTag() {
      this.getUserTagList()
      // this.getUserStatusList()
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        response.result.map((item) => {
          this.tagOptions.push(item.name)
        })
      }
    },
    clearSearch() {
      this.input = {
        search: '',
        phoneno: '',
        ticketStatus: '',
        tags: ''
      }
      this.searchBoxModal = false
      this.$emit('onclearsearch', this.input)
    },
    onSearch() {
      this.$emit('onsearch', this.input)
      this.searchBoxModal = false
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentSearchBox.vue